function _hj(method: string, ...data: unknown[]): void {
  if (typeof window !== 'undefined' && window.hj) {
    window.hj('consent', true);
    window.hj(method, ...data);
  }
}

export default {
  event: (name: string, ...data: unknown[]): void => {
    _hj('event', name, ...data);
  },
  identify: (
    id: string | number,
    properties: Record<string, unknown> = {},
  ): void => {
    _hj('identify', id, {
      userId: id,
      ...properties,
    });
  },
};
